
export var actionTypes = {
    passwordChange: 1,
    taskConfirm: 2,
    scheduleUpdate: 3,
    flightServiceUpdate: 4,
    extraOrder: 5,
    centeringUpdate: 6,
    taskStart: 7,
    taskFinish: 8,
    createNewBoard: 9,
    taskWorkUpdate: 10,
    freeTaskConfirm: 11,
    setWeapon: 12,
    taskOperationSave: 13,
    passengersInfoSave: 14,
    registrationBeginTimeSave: 15,
    registrationEndTimeSave: 16,
    registrationLastPaxQueueTimeSave: 17,
    registrationAvgPaxQueueTimeSave: 18,
    registrationPaxRegPercentSave: 19,
    boardingBeginTimeSave: 20,
    boardingEndTimeSave: 21,
    boardingScanBeginTimeSave: 22,
    boardingScanEndTimeSave: 23,
    boardingBusesSave: 24,
    flightFuelSave: 25,
    taskComment: 26
};

export var scheduleOperationTypes = {
    startTime: 0,
    endTime: 1,
    commonTime: 2,
    comment: 3,
    taskComment: 4,
    cancelComment: 5,
    saveOperationValue: 6
};

export var taskWorkOperationTypes = {
    setTime: 1,
    cancelWork: 2
};

export var workplaceTypes = {
    supervisor: 1,
    executor: 2,
    driver: 3,
    agent: 4,
    security: 5,
    conveyer: 6
};

export var resourceTypes = {
    registration: 2,
    boarding: 6
};

export var flightTypes = {
    departure: 0,
    arrival: 1,
    around: 2
};

export var flightRegistrationDataTypes = {
    beginTime: 1,
    endTime: 2,
    lastPaxQueueTime: 3,
    avgPaxQueueTime: 4,
    paxRegPercent: 5
};

export var flightBoardingDataTypes = {
    beginTime: 1,
    endTime: 2,
    scanBeginTime: 3,
    scanEndTime: 4,
    buses: 5
};
